import React from "react";
import { WBMFormatMoney } from "wbm-format-money";

const CartItemChild = ({
  cartItem,
  itemTotal,
  discountTotal,
  useMobile,
  ...props
}) => {
  const calculateKitQty = () => {
    const qty = cartItem.qty;
    const kitItemQty = cartItem.kitItemQty;
    const originalComponentQuantity = qty / kitItemQty;
    return originalComponentQuantity * cartItem.submittedKitQty;
  };

  const kitItemPrice = <WBMFormatMoney amount={itemTotal} useCurrencySign />;
  const discountPrice = (
    <WBMFormatMoney amount={discountTotal} useCurrencySign />
  );

  return (
    <div className="row no-gutters wbmcid-item no-border">
      <div className="col">
        <div
          className={
            "wbmcid-item-details-container pl-0" +
            (useMobile ? " use-mobile" : "")
          }
        >
          <div className="wbmcid-item-details-heading">
            {cartItem.brandName} {cartItem.description}
          </div>
          <div className="wbmcid-text-gray">
            {cartItem.itemIdentifier.id}
            {cartItem.itemIdentifier.couponOfferCode}
          </div>
        </div>
        <div className="wbmcid-item-image-container">
          <div className="wbmcid-text-gray text-center pt-0">
            QTY: {cartItem.submittedKitQty ? calculateKitQty() : cartItem.qty}
          </div>
        </div>
        <div className="wbmcid-item-pricing-container">
          <b className={discountTotal >= 0 ? "wbmcid-cross-out" : ""}>
            {kitItemPrice}
          </b>
          {discountTotal >= 0 ? (
            <div className="font-weight-bold wbmcid-text-red">
              {discountPrice}
            </div>
          ) : null}
          <div className="wbmcid-text-gray">
            ${cartItem.sellPrice.toFixed(2)} /{" "}
            {cartItem.itemIdentifier.unitId.toUpperCase()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartItemChild;
